import React from 'react';
interface ScrollHintTableProps {
  children: React.ReactNode;
  minWidth?: string;
}
export function ScrollHintTable({
  children,
  minWidth = '560px'
}: ScrollHintTableProps) {
  return <div data-id="element-270" data-mp="1i7eim9hxx1bw">
      <p className="mb-2 text-center text-xs font-medium text-gris-muted sm:hidden" data-id="element-271" data-mp="1i6wgiw8ljsw2">
        ← Desliza para ver la tabla completa →
      </p>
      <div className="scrollbar-hide overflow-x-auto rounded-2xl border border-gris-claro" data-id="element-272" data-mp="1mz6445m8ogv6">
        <div style={{
        minWidth
      }} data-id="element-273" data-mp="1rwg3oe3ce8wq">{children}</div>
      </div>
    </div>;
}